import { Users, GraduationCap, HeartHandshake, Baby, Music, Leaf } from 'lucide-react';

const areas = [
  { icon: Users, title: 'Aktywność i integracja społeczna', desc: '20+ lat łączenia wspólnot' },
  { icon: GraduationCap, title: 'Edukacja i wyrównywanie szans', desc: 'Warsztaty, szkolenia, programy' },
  { icon: HeartHandshake, title: 'Wsparcie osób wykluczonych', desc: 'Aktywizacja i reintegracja' },
  { icon: Baby, title: 'Dzieci i młodzież', desc: 'LEGO, MRG, programy liderskie' },
  { icon: Music, title: 'Sport, kultura i turystyka', desc: 'Festiwale, Bieg Mikołajkowy, wydarzenia' },
  { icon: Leaf, title: 'Zrównoważony rozwój', desc: 'Ekologia i środowisko' },
];

const DzialamySection = () => {
  return (
    <section className="py-16 lg:py-24 bg-muted/50">
      <div className="container">
        <h2 className="text-3xl lg:text-4xl font-heading font-bold mb-10 text-center">Nasze obszary działania</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {areas.map((a, i) => (
            <div key={i} className="bg-card rounded-panel p-6 border hover:shadow-md transition-shadow">
              <a.icon className="w-8 h-8 text-secondary mb-4" />
              <h3 className="font-heading font-bold text-lg mb-2">{a.title}</h3>
              <p className="text-sm text-muted-foreground">{a.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DzialamySection;
